<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    :isConfirm="isConfirm"
    :class="{ hideButton: isDisabled }"
    :width="width"
  >
    <div slot="content">
      <el-form
        ref="form"
        label-width="120px"
        :model="dataForm"
        :disabled="isDisabled"
      >
        <el-form-item label="项目编号：">
          <p>{{ dataForm.ProjectCode }}</p>
        </el-form-item>
        <el-form-item label="项目名称：">
          <p>{{ dataForm.ProjectName }}</p>
        </el-form-item>
        <!-- <el-form-item label="是否求助项目：">
          <el-radio-group v-model="dataForm.IsHelp">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="求助类型：">
          {{ showHelpType(dataForm.HelpType) }}
        </el-form-item> -->
        <el-form-item label="是否接受捐赠：">
          <el-radio-group v-model="dataForm.IsDonation">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="项目类型：">
          <p>{{ dataForm.ProjectType }}</p>
        </el-form-item>
        <el-form-item label="项目归属：">
          <p>{{ dataForm.TeamName }}</p>
        </el-form-item>
        <el-form-item label="项目截止时间：">
          <p v-if="dataForm.EndTime">
            {{ (dataForm.EndTime * 1000) | formatDate }}
          </p>
          <p v-else>长期</p>
        </el-form-item>

        <el-form-item label="封面图：" v-if="dataForm.CoverMap">
          <of-upload
            class="upload-demo"
            list-type="picture-card"
            @onPreview="onPreview"
            :limit="1"
            :fileList="pictureList"
            :class="{ hide: hideUploadEdit }"
            accept="image/jpeg, image/gif, image/png, image/jpg"
          >
            <div slot="content">
              <i slot="default" class="el-icon-plus"></i>
            </div>
          </of-upload>
          <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item label="附件：" v-if="dataForm.File">
          <el-upload
            class="upload-demo"
            action="/api/File/FileUpload"
            :on-preview="onFilePreview"
            :file-list="fileList"
          >
          </el-upload>
        </el-form-item>
        <el-form-item label="摘要：">
          <p>{{ dataForm.Abstract }}</p>
        </el-form-item>
        <el-form-item label="项目介绍：">
          <of-tinymce
            ref="editor"
            v-model="dataForm.Describe"
            :height="500"
            :isEdit="isDisabled"
          ></of-tinymce>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import OfTinymce from "@/components/controls/of_editor/of_tinymce_readonly";
import api from "@/modules/zjrc/api";
import { saveAs } from "file-saver";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
    formTitle: {
      type: String,
      default: "",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isConfirm: false,
      pictureList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      isdisabled: false,
      hideUploadEdit: false,
      width: "80%",
      fileList:[]
    };
  },
  mounted() {
    this.getImg();
    this.getlistfile();
  },
  components: {
    OfDialog,
    OfUpload,
    OfTinymce,
  },
  computed: {},
  methods: {
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //查看图片
    onPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    getImg() {
      const vm = this
      if (
        vm.dataForm.CoverMap === undefined ||
        vm.dataForm.CoverMap === null ||
        vm.dataForm.CoverMap == ""
      ) {
        return;
      }
      vm.hideUploadEdit = true;
      const obj = JSON.parse(vm.dataForm.CoverMap)
      vm.pictureList.push(obj)
    },
    showHelpType(helpType) {
      switch (helpType) {
        case 1:
          return "大病求助";
        case 2:
          return "困难家庭儿童白血病救助";
        case 3:
          return "贫困家庭先天性心脏病一心公益基金救助";
        case 4:
          return "贫困家庭先天性心脏病李家杰珍惜生命基金救助";
      }
    },
    //加载文件
    getlistfile() {
      let that = this;
      if (that.dataForm.File || that.dataForm.File != null) {
        let params = { Id: that.dataForm.File };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              that.fileList.push({
                url: item.Url,
                name: item.FileName,
              });
            });
          }
        });
      }
    },
    //附件下载
    onFilePreview(file) {
      saveAs(file.url, file.name);
    },
  },
};
</script>


<style scoped>
.el-textarea > textarea {
  height: 80px;
}

.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.upload-demo>>>.el-upload--text{
  display: none !important;
}

.el-date-editor >>> .el-input__icon {
  display: none;
}
.el-date-editor >>> .el-input__inner {
  width: 90%;
}
.el-form >>> .el-form-item {
  margin-bottom: 0;
}
</style>

<style>
.hide {
  display: block !important;
}

.hideFile .el-upload--fileList {
  display: none;
}

.hideButton .el-button--primary {
  display: none;
}
</style>
